import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const state = {
  showIMG: false,
  imagesList:[],
  user:{}
}
const getters = {
  showIMG () {
    return state.showIMG
  },
  user (){
    return state.user
  },
  imagesList(){
    return state.imagesList
  }
}
const mutations={
  setShowIMG(state,code){
    return state.showIMG=code
  },
  setUser(state,code){
    return state.user=code
  },
  setImagesList(state,data){
    return state.imagesList=data
  }
}
const actions = {
  setShowIMG (store, data) {
    store.commit('setShowIMG', data)
  },
  setImagesList (store, data) {
    store.commit('setImagesList', data)
  },
  setUser (store, data) {
    store.commit('setUser', data)
  }
}

const index = new Vuex.Store({
  state,
  getters,
  mutations,
  actions
})

export default index



// WEBPACK FOOTER //
// ./src/store/index.js